var load = 0;

var installationSwiper = new Swiper('.installation-swiper-container', {
  keyboard: true,
  autoHeight: true,
  pagination: {
    el: '.installation-swiper-fraction',
    type: 'fraction',
    renderFraction: function (currentClass, totalClass) {
      return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span>`;
  	}
  },
  navigation: {
    nextEl: '.installation-swiper-next',
    prevEl: '.installation-swiper-prev',
  },
  effect: "fade",
      	fadeEffect: {
    		crossFade: true
  		},
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 3,
  },
  on: {
    lazyImageReady: function() {
      var swiper = this;
      
      if(load == 0){
      
        setTimeout(function() {
        	installationSwiper.updateAutoHeight();
          console.log("loaded")
      	}, 1000);
        
        load = 1;
        
      }
    }
  }
});
  
  
var selectedWorksSwiper = new Swiper('.selected-works-swiper-container', {  
  keyboard: true,
  autoHeight: false,
  pagination: {
    el: '.selected-works-swiper-fraction',
    type: 'fraction',
    renderFraction: function (currentClass, totalClass) {
      return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span>`;
  	}
  },
  navigation: {
    nextEl: '.selected-works-swiper-next',
    prevEl: '.selected-works-swiper-prev',
  },
  effect: "fade",
      	fadeEffect: {
    		crossFade: true
  	  	},
  preloadImages: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 3
  }
});
  
  
  
$(".selected-works-thumbnails img").on("click",function(){
  
  selectedWorksSwiper.slideTo($(this).index());
  
  $("html,body").animate({
    "scrollTop": $(".selected-works-swiper-container").offset().top
  }, 200);
  
});
  



$("nav.secondary a").on("click",function(e){
  
  e.preventDefault();
  
  var t = $(this).attr("href");
  
  $("html,body").animate({
    "scrollTop": $(t).offset().top - 75
  },1000);
  
  $("nav.secondary li").removeClass("a");
  $(this).find("li").addClass("a");

});
  